import React from "react";

function Risco() {
  return (
    <div className="home">
      <iframe
        title="Adquirencia"
        class="video"
        widht="100%"
        height="100%"
        src="https://app.powerbi.com/reportEmbed?reportId=78602a68-c475-471d-af3c-2a78a5b121bf&autoAuth=true&ctid=f88c7305-11d1-4b34-a8a0-da6536019e31"
        marginheight="0"
        marginwidth="0"
        scrolling="0"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </div>
  );
}

export default Risco;
